import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {reduxForm} from 'redux-form';
import {withSnackbar} from 'notistack';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';
import TabContainer from './TabContainer'
import {apvgkReportsConstants} from "../../../constants/apvgkReportsConstants";
import ReasonModal from './ReasonModal'
import {apvgkReportsService} from "../../../services/apvgkReportsService";
import {roleConstants} from "../../../constants/roleConstants";
import {Check as CheckIcon, Close as CloseIcon} from '@material-ui/icons';
import {isObject} from "formik";
import {isArray} from "leaflet/src/core/Util";
import GrzCheckStatusIcon from "./GrzCheckStatusIcon";
import SmevStatus from "./SmevStatus";
import PhotoModal from "../../admin/track/PhotoModal";


let WorkReportsTab = props => {
    const {
        classes,
        apvgkReports,
        paginateProps,
        authentication,
    } = props;

    const {user} = authentication;
    const signed = apvgkReports.tabStatus === apvgkReportsConstants.STATUS_ACCEPT;
    const work = apvgkReports.tabStatus === apvgkReportsConstants.STATUS_IN_WORK;
    const canceled = apvgkReports.tabStatus === apvgkReportsConstants.STATUS_DECLINE;
    return (
        <TabContainer paginateProps={paginateProps}>
            {(items, onItem) => (
                <React.Fragment>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID акта</TableCell>
                            <TableCell>Дата создания</TableCell>
                            <TableCell>АПВГК</TableCell>
                            <TableCell>ГРЗ ТС</TableCell>
                            <TableCell>СМЭВ</TableCell>
                            {signed && <TableCell>ЦАФАП</TableCell>}
                            <TableCell>{work ? 'Дата взятия акта в работу'
                                : (signed ? 'Дата одобрения акта' : 'Дата отклонения акта')
                            }</TableCell>
                            <TableCell>{work ? 'Сотрудник взявший акт в работу'
                                : (signed ? 'Сотрудник одобривший акт' : 'Сотрудник отклонивший акт')}
                            </TableCell>
                            <TableCell>{canceled ? 'Причина отклонения'
                                : 'Действие'
                            }</TableCell>
                            <TableCell>Скорость</TableCell>
                            <TableCell>Направление</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {items ? items.map(viewData => {
                            const [showReason, setShowReason] = React.useState(false)
                            return (
                                <TableRow
                                    key={`application-${viewData.id}`}
                                >
                                    <TableCell>
                                        <Link to={''}
                                              onClick={(e) => {
                                                  e.preventDefault()
                                                  apvgkReportsService.downloadFile(viewData.id)
                                              }}
                                              target="_blank"
                                        >{viewData.id}</Link>
                                    </TableCell>
                                    <TableCell>{viewData.date_create}</TableCell>
                                    <TableCell>{viewData.apvgk.equipment_seria_number + ' (' + viewData.apvgk.name + ')'}</TableCell>
                                    <TableCell>
                                        <PhotoModal id={viewData.apvgk_violation.id} label={viewData.apvgk_violation.TrackStateNumber}/>
                                        {work && <GrzCheckStatusIcon report={viewData}/>}
                                    </TableCell>
                                    <TableCell>
                                        <SmevStatus processing={viewData}/>
                                    </TableCell>
                                    {signed && (
                                        <TableCell>
                                            {viewData.cafap_result && (isObject(viewData.cafap_result) || isArray(viewData.cafap_result)) &&
                                                (Object.keys(viewData.cafap_result).length == 1 && viewData.cafap_result.return
                                                        ? <CheckIcon style={{color: 'green'}}/>
                                                        : <CloseIcon color={"error"}/>
                                                )}
                                        </TableCell>
                                    )}
                                    <TableCell>{work ? viewData.date_in_work : viewData.date_update}</TableCell>
                                    <TableCell>{(viewData.user || {}).name}</TableCell>
                                    <TableCell align={"right"} className="nowrap">
                                        {!canceled && user.role_id == roleConstants.ROLE_APVGK &&
                                            <Button className="info-btn" onClick={() => {
                                                onItem(viewData)
                                            }}>Подробнее</Button>}
                                        {canceled && (
                                            viewData.reason
                                        )}
                                        {showReason && (<ReasonModal report={viewData} onClose={() => {
                                            setShowReason(false)
                                        }}/>)}
                                    </TableCell>
                                    <TableCell>
                                        {viewData.apvgk_violation.Speed}
                                    </TableCell>
                                    <TableCell>
                                        {viewData.apvgk_violation.PlatformId}
                                    </TableCell>
                                </TableRow>
                            );
                        }) : null}
                    </TableBody>
                </React.Fragment>
            )}
        </TabContainer>
    );
};

const mapStateToProps = state => state;

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const {apvgkReports, authentication, filterData} = stateProps;
    const {dispatch} = dispatchProps;


    return {
        ...ownProps,
        apvgkReports,
        authentication,
        dispatch,
    };
};

WorkReportsTab = reduxForm({
    form: 'apvgk-reports-towork-form',
    enableReinitialize: true
})(WorkReportsTab);

export default compose(
    withStyles(() => {
    }),
    withSnackbar,
    connect(
        mapStateToProps,
        null,
        mergeProps
    )
)(WorkReportsTab);
